import React, { Component } from 'react';
import { Facebook, Instagram, Youtube, MapPin, Phone, Mail } from 'lucide-react';
type PageView = 'home' | 'archive' | 'detail' | 'configurator' | 'warranty' | 'instructions' | 'contact' | 'media' | 'dealers';
interface FooterProps {
  onNavigate?: (page: PageView, productId?: number) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="bg-charcoal text-white pt-20 pb-10 border-t-4 border-primary" data-id="element-39">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-41">
          {/* Brand Column */}
          <div data-id="element-42">
            <div className="mb-8" data-id="element-43">
              <img src="https://cdn.magicpatterns.com/uploads/q4av7SXkTh841TBiCeZ1dj/PRO-Logo.png" alt="Pro One Design" className="h-24 w-auto object-contain" data-id="element-44" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 font-sans" data-id="element-45">
              Premium manufacturing of lift kits, leveling kits, and suspension
              components. Engineered for performance, built for durability.
            </p>
            <div className="flex gap-4" data-id="element-46">
              {[Facebook, Instagram, Youtube].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-primary hover:text-white transition-colors text-gray-400 border border-gray-700" data-id="element-47">
                  <Icon className="w-5 h-5" data-id="element-48" />
                </a>)}
            </div>
          </div>

          {/* Shop Links */}
          <div data-id="element-49">
            <h3 className="text-xl font-heading font-bold uppercase italic tracking-wider mb-6 text-white border-l-4 border-primary pl-3" data-id="element-50">
              Shop
            </h3>
            <ul className="space-y-3 text-gray-400 text-sm font-sans" data-id="element-51">
              {[{
              label: 'Lift Kits',
              action: 'archive' as PageView
            }, {
              label: 'Leveling Kits',
              action: 'archive' as PageView
            }, {
              label: 'Shocks & Struts',
              action: 'archive' as PageView
            }, {
              label: 'Control Arms',
              action: 'archive' as PageView
            }, {
              label: 'Steering Components',
              action: 'archive' as PageView
            }, {
              label: 'Accessories',
              action: 'archive' as PageView
            }].map(item => <li key={item.label} data-id="element-52">
                  <button onClick={() => onNavigate && onNavigate(item.action)} className="hover:text-primary transition-colors flex items-center gap-2 group text-left" data-id="element-53">
                    <span className="w-1 h-1 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-54" />
                    {item.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Support Links */}
          <div data-id="element-55">
            <h3 className="text-xl font-heading font-bold uppercase italic tracking-wider mb-6 text-white border-l-4 border-primary pl-3" data-id="element-56">
              Support
            </h3>
            <ul className="space-y-3 text-gray-400 text-sm font-sans" data-id="element-57">
              {[{
              label: 'Installation Guides',
              action: 'instructions' as PageView
            }, {
              label: 'Warranty Information',
              action: 'warranty' as PageView
            }, {
              label: 'Media',
              action: 'media' as PageView
            }, {
              label: 'Dealer Locator',
              action: 'dealers' as PageView
            }, {
              label: 'Contact Us',
              action: 'contact' as PageView
            }].map(item => <li key={item.label} data-id="element-58">
                  <button onClick={() => onNavigate && onNavigate(item.action)} className="hover:text-primary transition-colors flex items-center gap-2 group text-left" data-id="element-59">
                    <span className="w-1 h-1 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-60" />
                    {item.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-61">
            <h3 className="text-xl font-heading font-bold uppercase italic tracking-wider mb-6 text-white border-l-4 border-primary pl-3" data-id="element-62">
              Contact Us
            </h3>
            <ul className="space-y-4 text-gray-400 text-sm font-sans" data-id="element-63">
              <li className="flex items-start gap-3" data-id="element-64">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-65" />
                <span data-id="element-66">
                  123 Offroad Way
                  <br data-id="element-67" />
                  Fresno, CA 93727
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-68">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" data-id="element-69" />
                <a href="tel:5591234567" className="hover:text-white transition-colors" data-id="element-70">
                  (559) 123-4567
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-71">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" data-id="element-72" />
                <a href="mailto:sales@proonedesign.com" className="hover:text-white transition-colors" data-id="element-73">
                  sales@proonedesign.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500 font-sans" data-id="element-74">
          <p data-id="element-75">
            &copy; {new Date().getFullYear()} Pro One Design. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-76">
            <a href="#" className="hover:text-white transition-colors" data-id="element-77">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-78">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-79">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
}